import React from "react";
import { Row } from "components/Layout";
import SettingItem from "./SettingItem"


export default function SettingsContainer({
	scope, settingItems, settingGroups, deviceId, projectId, projectTypeId, getSettingValue, changeSetting, deleteSetting
}) {
	return settingGroups ? (
		settingGroups.map(group => {
			let groupItems = settingItems.filter(s => s.groupName === group.name);
			return groupItems.length > 0 && (
				<div key={group.name}>
					<Row>
						<label className="groupLabel">{group.label}</label>
					</Row>
					<Row>{
						groupItems.map(sItem =>
							<SettingItem
								key={sItem.name}
								containerScope={scope}
								settingItem={sItem}
								onChange={v => changeSetting(sItem.name, v, projectTypeId, projectId, deviceId)}
								setting={getSettingValue(sItem.name, projectTypeId, projectId, deviceId)}
								onDelete={deleteSetting}
							/>
						)
					}</Row>
				</div>
			)
		})
	) : (
		<Row>{
			settingItems.map(sItem =>
				<SettingItem
					key={sItem.name}
					containerScope={scope}
					settingItem={sItem}
					onChange={v => changeSetting(sItem.name, v, projectTypeId, projectId, deviceId)}
					setting={getSettingValue(sItem.name, projectTypeId, projectId, deviceId)}
					onDelete={deleteSetting}
				/>
			)
		}</Row>
	)
}
